import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights, formatIndianNumber } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetDestinationWisePerformanceReport } from "../services/reports.services";

const DestinationWisePerformanceReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/destinationwiseperformancereportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/destinationwiseperformancereportform",
    PRINT_ACCESS
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const RegionID = params?.RegionID;
  const CountryID = params?.CountryID;
  const filterCreatedBy = params?.filterCreatedBy;
  const RequirementType = params?.RequirementType;

  const loading = useAppSelector((state) => state.reports.loading);
  const destinationwiseperformanceListForReport = useAppSelector(
    (state) => state.reports.destinationwiseperformanceListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        RequirementType: RequirementType !== "0" ? RequirementType : "",
        RegionID: RegionID !== "0" ? RegionID : 0,
        CountryID: CountryID !== "0" ? CountryID : 0,
        AssignedUserId: filterCreatedBy !== "0" ? filterCreatedBy : 0,
      };
      dispatch(GetDestinationWisePerformanceReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "DestinationWisePerformance");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "destinationwiseperformancereport.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Destination Wise Performance Report{" "}
          <span style={{ fontSize: 15 }}>
            {destinationwiseperformanceListForReport &&
              destinationwiseperformanceListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            destinationwiseperformanceListForReport &&
            destinationwiseperformanceListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            destinationwiseperformanceListForReport &&
            destinationwiseperformanceListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {destinationwiseperformanceListForReport &&
      destinationwiseperformanceListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  No
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Destination
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Total Inquiries
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Quotation Sent
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Booking Confirmed
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Total Revenue
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Average Booking Value
                </th>
              </tr>
            </thead>
            <tbody>
              {destinationwiseperformanceListForReport &&
                destinationwiseperformanceListForReport.length > 0 &&
                destinationwiseperformanceListForReport?.map(
                  (destinationwiseperformance: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {destinationwiseperformance?.Destination || ""}
                      </td>
                      <td className="text-center">
                        {destinationwiseperformance?.TotalInquiries || ""}
                      </td>
                      <td className="text-center">
                        {destinationwiseperformance?.QuotationSent || ""}
                      </td>
                      <td className="text-center">
                        {destinationwiseperformance?.BookingConfirmed || ""}
                      </td>

                      <td className="text-end">
                        {destinationwiseperformance?.TotalRevenue
                          ? formatIndianNumber(
                              destinationwiseperformance?.TotalRevenue
                            )
                          : ""}
                      </td>
                      <td className="text-end">
                        {destinationwiseperformance?.AverageBookingValue || ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default DestinationWisePerformanceReportView;
